function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "18",
  viewBox: "0 0 22 18"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.57 18c-.75 0-1.446-.319-1.956-.9L.832 11.983A3.104 3.104 0 010 9.857c0-.796.296-1.55.832-2.126 1.07-1.144 2.917-1.137 3.933.016L7.42 10.59c.07.077.263.077.336 0L16.849.853c1.072-1.145 2.918-1.135 3.934.017.523.561.827 1.357.817 2.17-.011.8-.312 1.54-.848 2.081L9.546 17.118c-.532.568-1.233.882-1.976.882zM2.81 8.457c-.36 0-.698.15-.954.425-.252.27-.39.616-.39.975s.138.704.39.974l4.796 5.134c.5.568 1.366.543 1.873.001l11.22-12.013c.252-.256.385-.583.39-.938a1.441 1.441 0 00-.39-1.011c-.5-.567-1.366-.545-1.874 0l-9.094 9.737c-.626.667-1.754.667-2.378 0l-2.67-2.859a1.207 1.207 0 00-.92-.425z",
  fill: "#0F0F0F",
  fillRule: "nonzero",
  opacity: ".8"
})));